import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(value: string | Date | null | undefined) {
  if (!value) return '—';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function knotsToKmh(knots: number): number {
  return knots * 1.852;
}

/** Velocidade náutica: nós como unidade primária (1 casa) + km/h entre parênteses. */
export function formatSpeed(knots: number | null | undefined): string {
  if (knots == null) return '—';
  const nos = knots.toFixed(1).replace('.', ',');
  return `${nos} nós (${Math.round(knotsToKmh(knots))} km/h)`;
}

/** Forma compacta só em nós (para chips/listas). */
export function formatKnots(knots: number | null | undefined): string {
  if (knots == null) return '—';
  return `${knots.toFixed(1).replace('.', ',')} nós`;
}

const RELATIVE = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });

export function formatRelativeTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '—';
  const diffSec = Math.round((date.getTime() - Date.now()) / 1000);
  const abs = Math.abs(diffSec);
  if (abs < 60) return RELATIVE.format(diffSec, 'second');
  if (abs < 3600) return RELATIVE.format(Math.round(diffSec / 60), 'minute');
  if (abs < 86_400) return RELATIVE.format(Math.round(diffSec / 3600), 'hour');
  if (abs < 30 * 86_400) return RELATIVE.format(Math.round(diffSec / 86_400), 'day');
  if (abs < 365 * 86_400) return RELATIVE.format(Math.round(diffSec / (30 * 86_400)), 'month');
  return RELATIVE.format(Math.round(diffSec / (365 * 86_400)), 'year');
}

export function formatCoords(lat: number | null | undefined, lon: number | null | undefined): string {
  if (lat == null || lon == null) return '—';
  return `${lat.toFixed(5)}, ${lon.toFixed(5)}`;
}
